import { BACKEND_TO_FRONTEND_STAGE } from './worldcupPicksData.helper';
import type { MemberProfileMatch } from './worldCupMemberProfileApi.helper';
import type { WorldCupMatch } from '../types/worldcup.types';

export function profileMatchToWorldCupMatch(m: MemberProfileMatch): WorldCupMatch {
  const stageMapper = BACKEND_TO_FRONTEND_STAGE[m.stage];
  const stageKey = stageMapper ? stageMapper(m.round) : 'first_round';
  return {
    id: m.matchId,
    homeTeam: m.homeTeam,
    awayTeam: m.awayTeam,
    homeCountryCode: m.homeCountryCode,
    awayCountryCode: m.awayCountryCode,
    // AC-3.8: without these the profile's cards draw the country flag, which turns every
    // Spanish club into Spain and makes a club competition read as a national-team one.
    homeKit: m.homeKit ?? null,
    awayKit: m.awayKit ?? null,
    kickoffTime: m.kickoffTime,
    status: m.status,
    round: m.round || '1',
    stageKey,
    stageLabel: m.stageLabel,
    homeScore: m.homeScore ?? undefined,
    awayScore: m.awayScore ?? undefined,
    fullTimeHomeScore: m.fullTimeHomeScore ?? undefined,
    fullTimeAwayScore: m.fullTimeAwayScore ?? undefined,
    penaltyHomeScore: m.penaltyHomeScore ?? undefined,
    penaltyAwayScore: m.penaltyAwayScore ?? undefined,
    liveMinute: m.liveMinute ?? undefined,
    isPickEditable: false,
    prediction: m.prediction
      ? {
          home: m.prediction.home,
          away: m.prediction.away,
          isMonkeyPick: m.prediction.isMonkeyPick,
          // A live match has no settled points until full-time, so fall through to the
          // provisional value the profile route now sends (specs/champions-league AC-18.6).
          // Without this the cards under the header showed nothing for a match the header was
          // already counting, and the cards no longer summed to the total.
          pointsEarned: m.prediction.pointsEarned ?? m.prediction.livePointsEarned ?? undefined,
          isBoosted: m.prediction.isBoosted,
        }
      : undefined,
  };
}
